import React from 'react';
import { Helmet } from 'react-helmet'
import * as SG from '../../constants/AppSettings'
import Modal from '../App/Modal'
import axios from 'axios';

export default class Component extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
    // console.log(this.props);
    this.state = {
      name: '',
      email: '',
      title: '',
      body: '',
      openModal: false,
    };
  }

  valueChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  openModal = () => {
    this.setState({openModal: true})
  }

  closeModal = () => {
    this.setState({openModal: false})
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.openModal()
  }

  submitInquiry = () => {
    const formData = new FormData
    formData.append("contact[name]", this.state.name)
    formData.append("contact[email]", this.state.email)
    formData.append("contact[subject]", this.state.title)
    formData.append("contact[content]", this.state.body)

    this.props.submitInquiry(formData)
    this.setState({ openModal: false })
  }

  checkAllEnter = () => {
    // 全入力チェック
    if (!!this.state['name'] && !!this.state['email'] && !!this.state['title'] && !!this.state['body']) {
      return true
    } else {
      return false
    }
  }

  render = () => {
    const metaInfo = (
      <Helmet>
        <title>お問い合わせ | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)のお問い合わせページです。サービスをご利用いただく上で、ご不明点やご意見がございましたらこちらのお問いあわせフォームに、要件とお名前のご記載をお願いいたします。いただいた内容はスタッフが対応させていただきます。' />
      </Helmet>
    )

    const modal = (
      <Modal
        okClickHandler={this.submitInquiry}
        headerTitle='お問い合わせ内容の確認'
        isOpen={this.state.openModal}
        closeModal={this.closeModal}
        noIcon={true}
        okText='送信する'
      >
        <table className='table'>
          <tbody className='align-top'>
            <tr>
              <th>氏名</th>
              <td>{this.state.name}</td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td>{this.state.email}</td>
            </tr>
            <tr>
              <th>件名</th>
              <td>{this.state.title}</td>
            </tr>
            <tr>
              <th>お問い合わせ内容</th>
              <td>{(() => {
                return(
                  this.state.body.replace(/\r?\n/g, "<br />").split('<br />').map((line) => {
                    return (<p className='mb0'>{line}</p>)
                  })
                )
              })()}</td>
            </tr>
          </tbody>
        </table>
      </Modal>
    )

    const canSubmit = this.checkAllEnter()

    return (
      <section className='inquiry container'>
        {metaInfo}
        {modal}
        <h2 className='headline'>お問い合わせ</h2>
        <form onSubmit={this.onSubmit} className='form text-left'>
          <div className='field'>
            <label htmlFor="name" className='need-icon'>氏名</label>
            <input type="text" name="name" value={this.state.name} onChange={this.valueChange} required />
          </div>
          <div className='field'>
            <label htmlFor="email" className='need-icon'>メールアドレス</label>
            <input type="email" name="email" value={this.state.email} onChange={this.valueChange} required />
          </div>
          <div className='field'>
            <label htmlFor="title" className='need-icon'>件名</label>
            <input type="text" name="title" value={this.state.title} onChange={this.valueChange} required />
          </div>
          <div className='field' className='need-icon'>
            <label htmlFor="body">お問い合わせ内容</label>
            <textarea name="body" id="" cols="30" rows="10" value={this.state.body} onChange={this.valueChange} style={{height: '10rem'}} required></textarea>
          </div>
          <input type="submit" value="確認" className={"btn btn-submit" + (canSubmit ? '' : ' disabled')} />
        </form>

      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Inquiry/Inquiry.jsx